<div>
    
    <div class="remote-application-container-root" #rootElement></div>
</div>
